"use strict";

exports.__esModule = true;
exports.MapPartProcessActionElement = void 0;
var _react = _interopRequireDefault(require("react"));
var _MapperDialog = require("../Dialogs/MapperDialog");
var _Timeline = require("../../Timeline");
var _useMappingProps2 = require("../Dialogs/useMappingProps");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var MapPartProcessActionElement = exports.MapPartProcessActionElement = function MapPartProcessActionElement(props) {
  var _useMappingProps = (0, _useMappingProps2.useMappingProps)(),
    isDialogOpen = _useMappingProps.isDialogOpen,
    childProps = _useMappingProps.childProps,
    translate = _useMappingProps.translate,
    device = _useMappingProps.device,
    toggleDialog = _useMappingProps.toggleDialog;
  if (!isDialogOpen) {
    return props.children(childProps);
  }
  var label = translate("MapPartProcessAction.updateMapping.label", "Map Part Process");
  var partLabel = translate("MapPartProcessAction.dialog.label", "Part Process");
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.children(childProps), /*#__PURE__*/_react["default"].createElement(_MapperDialog.MapperDialog, {
    label: label,
    partLabel: partLabel,
    isOpen: isDialogOpen,
    toggleDialog: toggleDialog,
    partMappingInputPlaceholder: translate("MapPartProcessAction.dialog.inputPlaceholder", "Enter new mapping"),
    type: "part-process-value-mapping",
    device: device,
    timelineName: _Timeline.TIME_SERIES_PROCESS
  }));
};